export const EncryptionKeyCloudVendor = {
    GCP: 'gcp',
} as const;

export type GcpEncryptionKeySecretManagerReference = {
    cloud_vendor: typeof EncryptionKeyCloudVendor.GCP;
    family: string;
    sequence_number: number;
};

export type EncryptionKeySecretManagerReference = GcpEncryptionKeySecretManagerReference;
